import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'
import type { UserService } from '~/api/services/types'
import type { User } from '~/types/user'

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): UserService => {
  return {
    getAllUsers: async (): Promise<User[]> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.GET_ALL_USERS)
      return await client<User[]>(url, { method, headers, body })
    }
  }
}
